import { Link, Stack, Tooltip } from "@mui/material";
import CopyToBufferButton from "@entrilia/shared/components/inputs/CopyToBufferButton";
import { getFileSystemPath, isFileUrl } from "@entrilia/shared/utilities/urlHelper";

interface Props {
  title: string;
  url: URL;
  noWrap?: boolean;
}

const getTooltipTitle = (title: string, fileSystemPath: string | undefined, noWrap: boolean | undefined): string => {
  if (fileSystemPath) {
    return `${fileSystemPath} — if the link doesn't open, copy the path and paste it into File Explorer.`;
  }
  return noWrap ? title : "";
};

const UrlFieldLink = ({ title, url, noWrap }: Props) => {
  const fileSystemPath = isFileUrl(url) ? getFileSystemPath(url) : undefined;

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", minWidth: 0 }}>
      <Tooltip title={getTooltipTitle(title, fileSystemPath, noWrap)}>
        <Link
          onClick={(e) => e.stopPropagation()}
          color="primary"
          href={url.href}
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
          noWrap={noWrap}
          sx={noWrap ? { display: "block", minWidth: 0 } : { overflowWrap: "anywhere" }}
        >
          {title}
        </Link>
      </Tooltip>
      {fileSystemPath && <CopyToBufferButton textToCopy={fileSystemPath} tooltipTitle="Copy path" />}
    </Stack>
  );
};

export default UrlFieldLink;
